import { logger } from '@adornis/base/logging.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { createPDFBufferFromComponent } from '@adornis/print/server/print-internals.js';
import { generateLoginToken } from '@adornis/users/server/token.js';
import { User } from './entities/user.js';

export const USER_SESSION_CREATION_TOKEN = '_adornis_login';

export async function printComponent(
  component: string,
  options: {
    queryParams?: Record<string, Maybe<string | boolean | number>>;
    timeout?: number;
    user?: NarrowedEntity<User, { _id: 1; _class: 1; firstName: 1; lastName: 1; title: 1 }>;
  },
) {
  let { queryParams, user, ...restOptions } = options;
  queryParams = queryParams ?? {};

  if (user) {
    queryParams[USER_SESSION_CREATION_TOKEN] = await generateLoginToken({
      userID: user._id,
      userClass: User._class,
      ttu: 1,
      ttl: 1000 * 60 * 1,
    });
  }

  const encodedParams = {} as Record<string, string>;
  for (const [key, value] of Object.entries(queryParams)) {
    if (value === null || value === undefined) void 0; // ignore value
    else if (typeof value === 'string') encodedParams[key] = value;
    else if (typeof value === 'number') encodedParams[key] = value + '';
    else if (typeof value === 'boolean') encodedParams[key] = value ? 'true' : 'false';
    else {
      logger.error({ value }, 'invalid query param');
      throw new Error('invalid query param: ' + value);
    }
  }

  return await createPDFBufferFromComponent({
    component,
    queryParams: new URLSearchParams(encodedParams).toString(),
    ...restOptions,
  });
}
